import HttpClient from "../HttpClient";

export class WalletService {
    async getUserWallet (userId: number){
        const res = await HttpClient.get(`/wallet/centaurus/${userId}`);
        return res?.data;
    }

    /**
     * Writes off a customer's negative wallet balance so they can book again. The backend derives
     * the credit from the wallet row itself — there is no amount to send — so the wallet always
     * lands on 0.00 and this can never hand the customer spendable balance.
     */
    async settleNegativeWalletBalance (userId: number, notes?: string){
        const payload: { userId: number; notes?: string } = { userId: Number(userId) };
        if (notes) {
            payload.notes = notes;
        }
        const res = await HttpClient.post(`/wallet/centaurus/settle-negative-balance`, payload);
        return res?.data;
    }
}